import moment from 'moment'

export default {
    params: ['hour'],
    validate: (value, { hour }) => hour ? moment(value, 'HH:mm') <= moment(hour, 'HH:mm') : true,
    message: (field, { hour }) => `${field} deve ser menor ou igual à ${hour}.`,
}